import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useTaxDomiciles = (profileUuid) => {
  const middleman = useMiddleman();
  return useQuery(['tax_domiciles', profileUuid], () => {
    return middleman.get(`/ql/crm/tax-domiciles/${profileUuid}`);
  }, { enabled: !!profileUuid, refetchOnWindowFocus: false });
};

export const useTaxDomicileHistory = (profileUuid, enabled) => {
  const middleman = useMiddleman();
  return useQuery(['tax_domicile_history', profileUuid], () => {
    return middleman.get(`/ql/crm/tax-domiciles/history/${profileUuid}`).then((res) => {
      return res.data;
    });
  }, { enabled: enabled, refetchOnWindowFocus: false });
};